<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <el-tabs type="border-card">
                <el-tab-pane :label="$t('message.' + langItem.langCode)"
                    v-for="(langItem, index) in detailInfo.lstGiftStoreLangDTO" :key="index">
                    <div class="panel-body">
                        <div class="ibox-content">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Centre Name
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstGiftStoreLangDTO.' + index + '.storeName'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }">
                                        <el-input v-model="langItem.storeName" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    District
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'districtCode'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }">
                                        <el-select v-model="detailInfo.districtCode" placeholder="District" clearable>
                                            <el-option v-for="item in districtGetlist" :key="item.districtCode"
                                                :label="item[districtNameLangMap[langItem.langCode]]"
                                                :value="item.districtCode">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Area
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstGiftStoreLangDTO.' + index + '.area'" :rules="{
                                        required: false,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }">
                                        <el-input v-model="langItem.area" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Address
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstGiftStoreLangDTO.' + index + '.address'" :rules="{
                                        required: true,
                                        message: $t('message.required'),
                                        trigger: 'blur'
                                    }">
                                        <el-input v-model="langItem.address" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Tel
                                </label>
                                <div class="col-sm-10">
                                    <el-form-item prop="tel" :rules="{
                                        required: false, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input v-model="detailInfo.tel" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">Opening Hours</label>
                                <div class="col-sm-10">
                                    <el-form-item :prop="'lstGiftStoreLangDTO.' + index + '.openHours'" :rules="{
                                        required: false, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-input v-model="langItem.openHours" show-word-limit></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">
                                    Status
                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="status" :rules="{
                                        required: false, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-select v-model="detailInfo.status"
                                            v-bind:placeholder='$t("message.PleaseSelect")'>
                                            <el-option v-for="item in statusMap" :key="item.value" :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-sm-2 control-label">

                                </label>
                                <div class="col-sm-4">
                                    <el-form-item prop="isPublic" :rules="{
                                        required: false, message: $t('message.required'), trigger: 'change'
                                    }">
                                        <el-radio v-model="detailInfo.isPublic" :label="1">Public</el-radio>
                                        <el-radio v-model="detailInfo.isPublic" :label="0">Private</el-radio>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="hr-line-dashed"></div>
                            <div class="form-group">
                                <div class="col-sm-12">
                                    <div class="pull-right">
                                        <el-button type="primary" @click="checkEvent()" v-if="(checkPermission('gift_store_LIST_EDIT') &&
                                            $route.query.id) ||
                                            (checkPermission('gift_store_LIST_ADD') &&
                                                !$route.query.id)
                                            ">Save</el-button>
                                        <el-button @click="showWarning()">{{
                                            $t("message.Cancel")
                                        }}</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </el-form>
    </div>
</template>
<script>
import config from "../config";

export default {
    mixins: [config.globalMixin],
    data() {
        return {
            detailInfo: {
                lstGiftStoreLangDTO: [],
                status: 1,
                tel: "",
                isPublic: 1
            },
            districtGetlist: [],
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        statusMap() {
            return [
                { value: 0, label: "Disable" },
                { value: 1, label: "Enable" },
            ]
        },
        districtNameLangMap() {
            return {
                "en_US": "districtNameEn",
                "zh_CN": "districtNameSc",
                "zh_HK": "districtNameTc",
            };
        },
    },
    watch: {
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true
        }
    },
    created() {
        this.getDistrictGetlist()
        var obj = [];
        for (var i = 0; i < this.$store.state.userInfo.language.length; i++) {
            obj.push({
                langCode: this.$store.state.userInfo.language[i].langCode,
                storeName: "",
                area: "",
                address: "",
                openHours: "",
            });
        }
        this.$set(this.detailInfo, "lstGiftStoreLangDTO", obj);
        this.init();
    },
    mounted() { },
    methods: {
        async getDistrictGetlist() {
            let obj = this.getAuthObj();
            obj.apiUrl = this.apiConfig.districtGetlist;
            let data = await this.$store.dispatch("apiEvent", obj);
            if (data == "000104") {
                this.timeoutEvent();
                return;
            }
            if (!data) return;
            this.$set(this, "districtGetlist", data.data.result);
        },
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.giftStoreDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                this.$set(this, "detailInfo", data.data.result);
                this.detailInfo.lstGiftStoreLangDTO = this.detailInfo.lstGiftStoreLangDTO
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
        },
        checkEvent: function () {
            this.$refs["detailInfo"].validate(valid => {
                if (valid) {
                    this.submit();
                } else {
                    this.$toastr.w(this.$i18n.t("message.fillRequired"));
                    return false;
                }
            });
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                                that.callDelete();
                            }
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                            }
                        }
                    ]
                });
            }
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                for (var key in this.detailInfo) {
                    if (key != "userId") obj[key] = this.detailInfo[key];
                }
                var data;
                if (this.$route.query.id) {
                    obj.id = this.detailInfo.id;
                    obj.lstGiftStoreLangDTO = this.detailInfo.lstGiftStoreLangDTO
                    obj.apiUrl = this.apiConfig.giftStoreUpdate;
                    data = await this.$store.dispatch("apiEvent", obj);
                } else {
                    obj.lstGiftStoreLangDTO = this.detailInfo.lstGiftStoreLangDTO
                    obj.apiUrl = this.apiConfig.giftStoreCreate;
                    data = await this.$store.dispatch("apiEvent", obj);
                }
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { }
        },
        Delete() {
            this.showWarning(1);
        },
        async callDelete() {
        },
    }
};
</script>
  